var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 315.97,
    height: 82.156,
    viewBox: "0 0 315.97 82.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "login-shape",
    d: "M1356.54,77.074c55.97-20.953,50.51-92.471,1.29-97.646-95.28-10.017-223.31-10.705-254.74,9.374-26.43,16.878-29.28,49.991-9.57,62.434C1116.23,65.577,1312.14,93.691,1356.54,77.074Z",
    transform: "translate(-1080.69)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginShape);
export default __webpack_public_path__ + "static/media/login_shape.de56d9c6.svg";
export { ForwardRef as ReactComponent };